var _rect, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-instagram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 5,
    ry: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.37a4 4 0 1 1-4.73-4.73 4 4 0 0 1 4.73 4.73z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 6.5,
    x2: 17.51,
    y2: 6.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.abb3b598fcabc075ab7809be63d4ff61.svg";
export { ForwardRef as ReactComponent };